/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';

import { Box } from '@mui/system';
import CardfordownloadEditViewAction from '../../../../common/components/CardfordownloadEditViewAction/CardfordownloadEditViewAction';
import AddDocsModalController from '../../../../common/Modals/Documents/AddDocsModal/AddDocsModalController';
import EditDocsModalController from '../../../../common/Modals/Documents/EditDocsModal/EditDocsModalController';
import _ from 'lodash';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import { Grid, Typography } from '@mui/material';
import { fonts, themes } from '../../../../common/themes/themes';
import ActivedocCard from '../../../../common/components/ActivedocCard';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import Warning from '../../../../common/Modals/WarningModal/Warning';
import ViewDocHistoryController from '../../../../common/Modals/Documents/History/ViewDocHistoryController';
import toast from 'react-hot-toast';

interface propsType {
  allDocsData: any;
  setDocsIdFordeletion: (id: number) => void;
  setEmpAttachedDoc: (id: number) => void;
  isLoading?: boolean;
  trans?: any;
}
const ActiveDocsPresenter: React.FC<propsType> = ({
  allDocsData,
  setDocsIdFordeletion,
  setEmpAttachedDoc,
  isLoading,
  trans,
}) => {
  const [addDocumentsModal, setAddDocumentsModal] = useState(false);
  const [editDocumentsModal, setEditDocumentsModal] = useState(false);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [docId, setDocsId] = useState<number>(0);

  const [IndividualDocuments, setEmpDocuments] = useState([]);

  const [viewEmpDocHistoryDetails, setViewEmpDocHistoryDetails] =
    useState(false);
  const [docdata, setDocdata] = useState({});

  const handleEditDocuments = (Docs: any) => {
    if (validateAction(Docs?.documen_type?.restrict_employee)) return;
    setEmpDocuments(Docs);
    setEditDocumentsModal(true);
  };
  const handleDeleteModal = (Docs: any) => {
    if (validateAction(Docs?.documen_type?.restrict_employee)) return;
    setDeleteConfirmModal(true);
    setDocsId(Docs.id);
  };

  const handleDeleteDocs = () => {
    setDocsIdFordeletion(docId);
    setDeleteConfirmModal(false);
  };

  const handleViewNDownload = (data: any) => {
    setViewEmpDocHistoryDetails(true);
    setDocdata(data);
  };

  const validateAction = (restrictEmployeeAction: number) => {
    if (restrictEmployeeAction === 1) {
      toast.error(trans('You are not allowed to perform this action'));
      return true;
    } else return false;
  }
  return (
    <>
      <ActivedocCard
        card_title={trans('Active Documents')}
        card_subtitle={`${trans('Total')}: ${allDocsData ? allDocsData?.length : 0
          }`}
        card_height="330px"
        onClick={() => setAddDocumentsModal(true)}
      >
        <Warning
          openmodal={deleteConfirmModal}
          oncancel={() => setDeleteConfirmModal(false)}
          infoMessage={trans('Are You Deleting this Document?')}
          onconfirm={handleDeleteDocs}
        />
        <Box style={{ marginBottom: '24px' }} />
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <div>
            {allDocsData?.length > 0 ? (
              _.map(allDocsData, (Docs: any) => {
                return (
                  <CardfordownloadEditViewAction
                    key={Docs?.identifier_number}
                    tile_value={Docs?.documen_type?.type}
                    subtitle1={`${trans('Identifier No')}: `}
                    IdentifierNo={Docs?.identifier_number}
                    Issuetitle={trans('Issue')}
                    IssueDate={Docs?.issue_date}
                    Expirytitle={trans('Expiry')}
                    ExpDate={Docs?.validity_date}
                    status={Docs?.doc_status}
                    country={Docs?.issue_country}
                    onEdit={() => handleEditDocuments(Docs)}
                    onDelete={() => handleDeleteModal(Docs)}
                    onView={() => handleViewNDownload(Docs)}
                  />
                );
              })
            ) : (
              <Grid container style={{ marginBottom: '2.5em' }}>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <img src={emptyIcon} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Not Added')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    {trans('Currently you haven’t any Active Documents')}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </div>
        )}
      </ActivedocCard>

      {/* Add New Documents */}
      {addDocumentsModal && (
        <AddDocsModalController
          isModalOpen={addDocumentsModal}
          closeModal={() => setAddDocumentsModal(false)}
          trans={trans}
        />
      )}
      {/* Edit Documents */}
      {editDocumentsModal && (
        <EditDocsModalController
          IndividualDocuments={IndividualDocuments}
          isModalOpen={editDocumentsModal}
          closeModal={() => setEditDocumentsModal(false)}
          trans={trans}
        />
      )}
      {viewEmpDocHistoryDetails && (
        <ViewDocHistoryController
          isModalOpen={viewEmpDocHistoryDetails}
          closeModal={() => setViewEmpDocHistoryDetails(false)}
          trans={trans}
          docdata={docdata}
        />
      )}
    </>
  );
};
export default ActiveDocsPresenter;
